import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { userActions } from '@/entities/user';
import { extractApiError } from '@/shared/lib/api/extractError';

import { referralApi } from '../api/referralApi';
import { referralActions } from './slice';
import { ClaimReferralResponse, JoinReferralResponse,ReferralStats } from './types';

function* fetchStatsSaga(): Generator {
  yield put(referralActions.setLoading(true));
  try {
    const stats = (yield call(referralApi.fetchStats)) as ReferralStats;
    yield put(referralActions.setStats(stats));
  } catch {
    yield put(referralActions.setStats(null));
  }
}

function* claimSaga(): Generator {
  yield put(referralActions.setClaiming(true));
  yield put(referralActions.resetClaimStatus());
  try {
    const result = (yield call(referralApi.claim)) as ClaimReferralResponse;
    const currency = result.currency ?? 'TON';
    yield put(referralActions.claimSuccess(`${result.claimed.toFixed(4)} ${currency} credited to your balance`));
    yield put(userActions.updateBalanceByCurrency({ currency, amount: result.claimed }));
    yield put(referralActions.fetchStatsRequest());
  } catch {
    yield put(referralActions.claimFailure('Failed to claim reward. Please try again.'));
  }
}

function* joinReferralSaga(action: PayloadAction<string>): Generator {
  yield put(referralActions.setJoining(true));
  yield put(referralActions.resetJoinStatus());
  try {
    (yield call(referralApi.joinReferral, action.payload)) as JoinReferralResponse;
    yield put(referralActions.joinSuccess('Successfully joined! You will now earn cashback.'));
    yield put(userActions.fetchUserRequest());
  } catch (err) {
    const message = extractApiError(err) || 'Failed to join referral. Please try again.';
    yield put(referralActions.joinFailure(message));
  }
}

export function* referralWatcher(): Generator {
  yield takeLatest(referralActions.fetchStatsRequest.type, fetchStatsSaga);
  yield takeLatest(referralActions.claimRequest.type, claimSaga);
  yield takeLatest(referralActions.joinRequest.type, joinReferralSaga);
}
